const notice = {
    state: {
        data: ''
    },
    mutations: {
        SET_NOTICE_DATA: (state, data) => {
            state.data = data;
        }
    },
    actions: {
        setNoticeData({
            commit
        }, arg) {
            commit('SET_NOTICE_DATA', arg)
        }
    }
}

export default notice